import { useContext } from "react";

import { LLMSSLConfigContext } from "../../contexts/user/LLMSSLConfigContext";

const useLLMSSLConfig = () => {
  const context = useContext(LLMSSLConfigContext);
  return context;
};

export default useLLMSSLConfig;
